import * as React from "react";
import CircularProgressWithLabel from "./CircularProgressWithLabel.js";
import Increment from "../functions/Increment.js";

function Idioms() {
  const spanish = Increment({  limite: 100, incremento: 10 });
  const english = Increment({  limite: 80, incremento: 10 });
  return (
    <>
      <div className="flex gap-10 mt-5">
        <div className="ml-[20%]">
          <CircularProgressWithLabel value={spanish} />
          <p className="text-xs text-white"> Español </p>
        </div>

        <div>
          <CircularProgressWithLabel value={english} />
          <p className="text-xs text-white"> Ingles </p>
        </div>
      </div>
    </>
  );
}

export default Idioms;
